import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React  from 'react';
import 'antd/dist/reset.css';

import {HUPOXNET} from './HUPOXNET';

function App() {

  return (


<div className="App">
<HUPOXNET />

  </div>
  );
}

export default App;